import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/auth";

export default function WhatsAppFloat() {
  const [wa, setWa] = useState("351000000000");

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => {
        if (r.data?.whatsapp) setWa(r.data.whatsapp.replace(/\D/g, ""));
      })
      .catch(() => {});
  }, []);

  return (
    <a
      href={`https://wa.me/${wa}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
